// extracted by mini-css-extract-plugin
export var col = "styles-module--col--5e707";
export var cols = "styles-module--cols--7307c";
export var pattern = "styles-module--pattern--0c9b9";
export var textLarge = "styles-module--textLarge--02f1c";
export var textMedium = "styles-module--textMedium--31812";
export var textNormal = "styles-module--textNormal--6cad2";
export var textSmall = "styles-module--textSmall--7b92e";
export var textTiny = "styles-module--textTiny--b648d";
export var textXsmall = "styles-module--textXsmall--caced";